var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiseibleTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 7.49996L15.2367 15.2556C15.1032 16.9923 13.655 18.3333 11.9132 18.3333H8.08677C6.34498 18.3333 4.89684 16.9923 4.76326 15.2556L4.16667 7.49996M17.5 5.83329C15.3351 4.77827 12.7614 4.16663 10 4.16663C7.23862 4.16663 4.66493 4.77827 2.5 5.83329M8.33333 4.16663V3.33329C8.33333 2.41282 9.07953 1.66663 10 1.66663C10.9205 1.66663 11.6667 2.41282 11.6667 3.33329V4.16663M8.33333 9.16662V14.1666M11.6667 9.16662V14.1666",
    stroke: "#C2C4C9",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiseibleTrash);
export default __webpack_public_path__ + "static/media/diseible-trash.a680c29c8c506c2623ea2a6b29a74802.svg";
export { ForwardRef as ReactComponent };